export const PLATFORM_INTERNAL_ATTR_NAMES: ReadonlySet<string> = new Set([
  'id',
  'predefined_name',
  'is_system',
  'is_group',
  'is_deleted',
  'created_at',
  'updated_at',
  'created_by',
  'platform_user_id',
  'account_minted',
])

export function boundAttrName(nameOrPath: string): string {
  return String(nameOrPath || '')
    .trim()
    .replace(/^object\./i, '')
    .toLowerCase()
}

export function isPlatformInternalAttr(name: string): boolean {
  return PLATFORM_INTERNAL_ATTR_NAMES.has(boundAttrName(name))
}

/**
 * True when an attribute must never surface as its own App field/column:
 * a platform-internal name (predefined_name, is_system, ...), an attribute
 * marked `props.platform_internal` (object-scoped — e.g. Roles.rights), a
 * translation sibling (`props.translation_of` — see
 * `core/designer/translations.py`), or a composite-type discriminator sibling
 * (`props.composite_type_of` — see `core/designer/composite.py`). Siblings are
 * edited only through the base field's own widget, never listed on their own.
 */
const REGISTER_MACHINERY_ATTR_NAMES: ReadonlySet<string> = new Set([
  'recorder_type',
  'recorder_id',
  'movement_type',
])

export function isAppHiddenAttr(attr: { name: string; props?: Record<string, unknown> | null }): boolean {
  return (
    isPlatformInternalAttr(attr.name) ||
    REGISTER_MACHINERY_ATTR_NAMES.has(boundAttrName(attr.name)) ||
    Boolean(attr.props?.platform_internal) ||
    Boolean(attr.props?.translation_of) ||
    Boolean(attr.props?.composite_type_of)
  )
}
